import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Button, Icon, Input, Modal, Form, Row, Col, Select, Radio, DatePicker, InputNumber, Spin, TreeSelect, message, TimePicker, Divider, Tabs } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import {
	changeResumeLibrary,
	selectResumeLibrary,
	updateResumeLibrary,
} from "../../actions/recruitment-actions";
import resumeLibraryService from "../../services/Recruitment/resume-library-service";
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
const webConfig = require('../../config.json');


class ResumeLibrary extends ReduxComponent {

	initReload = true;
	moduleName = "recruitment";
	childModuleName = "resumeLibrary";

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		interviewModalStatus: false,
		interviewIndex: null,
		interviewData: {},
		interviewDataStatus: "unload",
		offers_resume_type: 1

	}

	actions = {
		changeAction: this.props.changeResumeLibrary,
		selectAction: this.props.selectResumeLibrary,
		updateAction: this.props.updateResumeLibrary,

		deleteAction: resumeLibraryService.deleteResumeLibrary,
		createAction: resumeLibraryService.createResumeLibrary,
		importAction: resumeLibraryService.importResumeLibrary,
		exportAction: resumeLibraryService.exportResumeLibrary,
		downloadTemplateAction: resumeLibraryService.downloadResumeLibraryTemplate,
		transAction:resumeLibraryService.transActionLibrary

	}

	setNameFilter = value => this.actions.changeAction({ username: value }, "reload")

	changeNameFilter = event => {
		if (!event.target.value) {
			this.actions.changeAction({ username: "" }, "reload")
		}
	}

	//简历库类型更改
	changeOffersResumeType = key => {
		this.state.offers_resume_type = key;
		this.actions.changeAction({ offers_resume_type: key }, "reload")
	}
	//简历库类型转移
transResumeType=type=>{
	if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
		message.error('请选择要转移的简历', 4);
		return false;
	}
	//收集选中ids，进行转移
	Modal.confirm({
		title: '确定转移选中的简历么?',
		okText: '确认',
		cancelText: '取消',
		onOk: () => {
			if ("function" === typeof this.actions.transAction) {
				this.actions.transAction({ids: this.state.selectedIDs,offers_resume_type:type}, res => {
					if (res.data.Success) {
						this.setState({selectedIDs: []});
						message.success('简历转移成功', 4);
						if ("function" === typeof this.actions.changeAction) {
							this.actions.changeAction();
						}else{
							this.handleError("undefined change action");
						}
					}else{
						message.error('简历转移失败' + res.data.Errors[0], 4);
					}
				});
			}else{
				this.handleError('undefined  action');
			}
		},
		onCancel: () => {}
	});
}

	setPositionFilter = value => this.actions.changeAction({ position_id: value }, "reload")

	createResume = () => this.setState({
		currentModalStatus: true,
		currentIndex: null,
		currentDataStatus: "unload",
		currentData: {
			gender: 1,
			department_id: "",
			department_name: "",
			position_id: "",
			position_name: "",
			work_type: "",
			work_experiences: [{
				company_kind: "",
				company_name: "",
				company_size: "",
				department_name: "",
				end_time: "",
				industry: "",
				position_name: "",
				responsibility: "",
				start_time: "",
				work_description: ""
			}
			],
			education_experiences: [{
				educational_level: "",
				end_time: "",
				is_all_day: true,
				profession: "",
				profession_description: "",
				school_name: "",
				start_time: ""
			}
			]
		}
	}, () => resumeLibraryService.initiaResumeLibrary({}, res => {
		if (res.data.Success) {
			this.setState({
				currentDataStatus: "loaded",
				...res.data.Object
			})
		} else {
			this.setState({ currentDataStatus: "error" })
		}
	}, err => this.setState({ currentDataStatus: "error" })))

	addWorkExperience = () => this.setState({
		currentData: {
			...this.state.currentData,
			work_experiences: [
				...this.state.currentData.work_experiences,
				{
					company_kind: "",
					company_name: "",
					company_size: "",
					department_name: "",
					end_time: "",
					industry: "",
					position_name: "",
					responsibility: "",
					start_time: "",
					work_description: ""
				}
			]
		}
	})

	deleteWorkExperience = index => this.setState({
		currentData: {
			...this.state.currentData,
			work_experiences: [
				...this.state.currentData.work_experiences.slice(0, index),
				{
					...this.state.currentData.work_experiences[index],
					deleted: true
				},
				...this.state.currentData.work_experiences.slice(index + 1)
			]
		}
	})

	addEducationExperience = () => this.setState({
		currentData: {
			...this.state.currentData,
			education_experiences: [
				...this.state.currentData.education_experiences,
				{
					educational_level: "",
					end_time: "",
					is_all_day: true,
					profession: "",
					profession_description: "",
					school_name: "",
					start_time: ""

				}
			]
		}
	})

	deleteEducationExperience = index => this.setState({
		currentData: {
			...this.state.currentData,
			education_experiences: [
				...this.state.currentData.education_experiences.slice(0, index),
				{
					...this.state.currentData.education_experiences[index],
					deleted: true
				},
				...this.state.currentData.education_experiences.slice(index + 1)
			]
		}
	})

	updateResume = (record, index) => this.setState({
		currentModalStatus: true,
		currentIndex: index,
		currentDataStatus: "unload",
	}, resumeLibraryService.selectResumeLibraryDetail({ id: record.id }, res => {
		if (res.data.Success) {
			this.setState({
				currentDataStatus: "loaded",
				currentData: res.data.Object.resume,
				company_kinds: res.data.Object.company_kinds,
				company_size: res.data.Object.company_size,
				departments: res.data.Object.departments,
				education_levels: res.data.Object.education_levels,
				work_types: res.data.Object.work_types,
				positions: res.data.Object.positions

			})
		} else {
			this.setState({ currentDataStatus: "error" })
		}
	}, err => this.setState({ currentDataStatus: "error" })))

	publicSubmit = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			let copyEducationExperiences = [];
			if (values.education_experiences) {
				values.education_experiences.forEach((experience, index) => {
					if (!experience.deleted) {
						let experienceItem = {
							...experience,
							start_time: moment(experience.start_time).format("YYYY-MM-DD"),
							end_time: moment(experience.end_time).format("YYYY-MM-DD")
						};
						if (this.state.currentData.education_experiences[index]) {
							experienceItem.id = this.state.currentData.education_experiences[index].id;
						}
						copyEducationExperiences.push(experienceItem);
					}
				})
			}
			let copyWorkExperiences = [];
			if (values.work_experiences) {
				values.work_experiences.forEach((experience, index) => {
					if (!experience.deleted) {
						let experienceItem = {
							...experience,
							start_time: moment(experience.start_time).format("YYYY-MM-DD"),
							end_time: moment(experience.end_time).format("YYYY-MM-DD")
						};
						if (this.state.currentData.work_experiences[index]) {
							experienceItem.id = this.state.currentData.work_experiences[index].id;
						}
						copyWorkExperiences.push(experienceItem);
					}
				})
			}
			let submitData = {
				...this.state.currentData,
				...values,
				start_working_time: moment(values.start_working_time).format("YYYY-MM-DD"),
				to_post_time: moment(values.to_post_time).format("YYYY-MM-DD"),
				birthday: moment(values.birthday).format("YYYY-MM-DD"),
				education_experiences: copyEducationExperiences,
				work_experiences: copyWorkExperiences
			}
			// console.log(submitData);
			var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
			if (submitData.email === "") {
				message.error("邮件不能为空", 4)
				return false;
			} else if (!reg.test(submitData.email)) {
				message.error("邮件格式不正确", 4)
				return false;
			}
			var myreg = /^[1][0-9]{10}$/;
			if (submitData.mobile === "") {
				message.error("手机号不能为空", 4)
				return false;
			} else if (!myreg.test(submitData.mobile)) {
				message.error("手机号格式不正确", 4)
				return false;
			}
			let callee = null === this.state.currentIndex ?
				this.publicCreate : this.publicUpdate;
			callee(submitData);
		} else {
			message.error("表单填写有误, 请检查表单", 4)
		}
	})

	arrangeInterview = id => this.setState({
		interviewDataStatus: "unload",
		interviewModalStatus: true
	}, () => resumeLibraryService.initiaInterviewManagement({ modelId: id }, res => {
		if (res.data.Success) {
			this.setState({
				interviewDataStatus: "loaded",
				interviewData: res.data.Object,
				interviewSubmitData: {
					offers_resume_id: "",
					interview_jobs: "",
					arrange_inte_time: "",
					interviewer_id: "",
					interview_times: "",
					interviewee_remind_type: "",
					interviewee_remind_temp_id: "",
					interviewer_remind_type: "",
					interviewer_remind_temp_id: ""
				},
				intervieweeTemplates: [],
				intervieweeCurrentTemplate: {},
				interviewerTemplates: [],
				interviewerCurrentTemplate: {}
			})
		} else {
			this.setState({ interviewDataStatus: "error" });
		}
	}, err => this.setState({ interviewDataStatus: "error" })))

	closeInterviewModal = () => {
		this.props.form.resetFields();
		this.setState({ interviewModalStatus: false });
	}

	closeCurrentModal = () => {
		this.props.form.resetFields();
		this.setState({ currentModalStatus: false })
	}


	column = [{
		title: '姓名',
		dataIndex: 'username',
		key: 'username',
		className: 'table-global-head-short'
	}, {
		title: '年龄',
		dataIndex: 'age',
		key: 'age',
		className: 'table-global-head-3x'
	}, {
		title: '期望职业',
		dataIndex: 'position_name',
		key: 'position_name',
		className: 'table-global-head-short'
	}, {
		title: '期望年收入(万元)',
		dataIndex: 'expected_salary',
		key: 'expected_salary',
		className: 'table-global-head'
	}, {
		title: '联系电话',
		dataIndex: 'mobile',
		key: 'mobile',
		className: 'table-global-head'
	}, {
		title: '邮箱',
		dataIndex: 'email',
		key: 'email',
		className: 'table-global-head-large'
	}, {
		title: '渠道',
		dataIndex: 'channel',
		key: 'channel',
		className: 'table-global-head'
	}, {
		title: '操作',
		dataIndex: 'actions',
		key: 'actions',
		className: 'table-global-head-16x',
		render: (text, record, index) => {
			return (
				<span>
					{this.props.access.resumeLibrary.u_value && <span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.updateResume.bind(this, record, index)}>编辑</Button>
					</span>}
					{this.props.access.resumeLibrary.arrange_cv_value && <span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.arrangeInterview.bind(this, record.id)}>安排面试</Button>
					</span>}
					{this.props.access.resumeLibrary.send_offer_value && <span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.sendOffer.bind(this, record.id)}>发送Offer</Button>
					</span>}
					{this.props.access.resumeLibrary.send_tm_value && <span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.sendTestimonial.bind(this, record.id)}>发送感谢信</Button>
					</span>}
				</span>
			)
		}
	}
	]

	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id + ""}
					key={item.id}
					dataRef={item}>
					{item.children.length !== 0 && this.renderTreeNodes(item.children)}
				</TreeSelect.TreeNode>
			);
		}
		return <TreeSelect.TreeNode {...item} />
	})

	setDepartment = (id, event) => {
		this.setState({
			positions: event.props.dataRef.positions,
			currentData: {
				...this.state.currentData,
				position_id: ""
			}
		}, () => this.props.form.setFieldsValue({ position_id: "" }))
	}

	setInterviewer = (value, event) => this.setState({
		interviewSubmitData: {
			...this.state.interviewSubmitData,
			interviewer_id: event.props.employee_id
		}
	})

	selectEmployee = value => this.props.fetchEmployeesList({ real_name: value })

	setIntervieweeRemindType = value => this.setState({
		intervieweeTemplates: this.state.interviewData[value],
		intervieweeCurrentTemplate: {}
	}, this.props.form.resetFields("interviewee_remind_temp_id"))

	setIntervieweeRemindTemp = (value, event) => this.setState({
		intervieweeCurrentTemplate: this.state.intervieweeTemplates[event.key],
	})

	setInterviewerRemindType = value => this.setState({
		interviewerTemplates: this.state.interviewData[value],
		interviewerCurrentTemplate: {}
	}, this.props.form.resetFields("interviewer_remind_temp_id"))

	setInterviewerRemindTemp = (value, event) => this.setState({
		interviewerCurrentTemplate: this.state.interviewerTemplates[event.key],
	})

	submitInterview = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			const interviewPostData = {
				offers_resume_id: this.state.interviewData.id,
				...values,
				interviewer_id: this.state.interviewSubmitData.interviewer_id,
				arrange_inte_time: values.interview_date.format("YYYY-MM-DD") + " " + values.interview_time.format("HH:mm")
			}
			if (values.interviewee_remind_type === "email_template") {
				interviewPostData.interviewee_remind_type = "2"
			}
			else if (values.interviewee_remind_type === "sms_template") {
				interviewPostData.interviewee_remind_type = "3"
			}
			if (values.interviewer_remind_type === "email_template") {
				interviewPostData.interviewer_remind_type = "2"
			}
			else if (values.interviewer_remind_type === "corporatewechat_template") {
				interviewPostData.interviewer_remind_type = "1"
			}
			delete interviewPostData.interview_date;
			delete interviewPostData.interview_time;
			delete interviewPostData.intervieweeCurrentTemplateContent;
			delete interviewPostData.interviewerCurrentTemplateContent;
			delete interviewPostData.interviewer_name;
			//console.log(interviewPostData);
			resumeLibraryService.createInterviewManagement(interviewPostData, res => {
				this.setState({ interviewModalStatus: false })
				if (res.data.Success) {
					message.success("安排面试成功", 4);
				} else {
					message.error("安排面试失败 " + res.data.Errors[0], 4);
				}
			}, err => message.error("安排面试失败", 4))
		}
	})

	closeOfferModal = () => this.setState({ offerModalStatus: false })

	sendOffer = id => {
		this.setState({
			offerModalStatus: true,
			offer_time: "",
			offerID: id
		}, () => resumeLibraryService.initiaInterviewManagement({ modelId: id }, res => {
			if (res.data.Success) {
				this.setState({
					interviewDataStatus: "loaded",
					interviewData: res.data.Object,
					interviewSubmitData: {
						offers_resume_id: "",
						interview_jobs: "",
						arrange_inte_time: "",
						interviewer_id: "",
						interview_times: "",
						interviewee_remind_type: "",
						interviewee_remind_temp_id: "",
						interviewer_remind_type: "",
						interviewer_remind_temp_id: ""
					},
					intervieweeTemplates: [],
					intervieweeCurrentTemplate: {},
					interviewerTemplates: [],
					interviewerCurrentTemplate: {}
				})
			} else {
				this.setState({ interviewDataStatus: "error" });
			}
		}, err => this.setState({ interviewDataStatus: "error" })))
	}

	submitOffer = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const interviewPostData = {
					id: this.state.offerID,
					...values,
					offer_time: values.offer_time.format("YYYY-MM-DD")
				}
				if (values.interviewee_remind_type === "email_template") {
					interviewPostData.interviewee_remind_type = "2"
				}
				else if (values.interviewee_remind_type === "sms_template") {
					interviewPostData.interviewee_remind_type = "3"
				}
				//console.log(interviewPostData);
				resumeLibraryService.sendOffer(interviewPostData, res => {
					this.setState({ offerModalStatus: false })
					if (res.data.Success) {
						message.success("发送Offer成功", 4);
					} else {
						message.error("发送Offer失败 " + res.data.Errors[0], 4);
					}
				}, err => message.error("发送Offer失败", 4))
			}
		})

	}

	closeTestimonialModal = () => this.setState({ testimonialModalStatus: false })

	sendTestimonial = id => {
		this.setState({
			testimonialModalStatus: true,
			testimonialID: id
		}, () => resumeLibraryService.initiaInterviewManagement({ modelId: id }, res => {
			if (res.data.Success) {
				this.setState({
					interviewDataStatus: "loaded",
					interviewData: res.data.Object,
					interviewSubmitData: {
						offers_resume_id: "",
						interview_jobs: "",
						arrange_inte_time: "",
						interviewer_id: "",
						interview_times: "",
						interviewee_remind_type: "",
						interviewee_remind_temp_id: "",
						interviewer_remind_type: "",
						interviewer_remind_temp_id: ""
					},
					intervieweeTemplates: [],
					intervieweeCurrentTemplate: {},
					interviewerTemplates: [],
					interviewerCurrentTemplate: {}
				})
			} else {
				this.setState({ interviewDataStatus: "error" });
			}
		}, err => this.setState({ interviewDataStatus: "error" })))
	}

	submitTestimonial = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const interviewPostData = {
					id: this.state.testimonialID,
					...values
					//offer_time: values.offer_time.format("YYYY-MM-DD")
				}
				if (values.interviewee_remind_type === "email_template") {
					interviewPostData.interviewee_remind_type = "2"
				}
				else if (values.interviewee_remind_type === "sms_template") {
					interviewPostData.interviewee_remind_type = "3"
				}
				//console.log(interviewPostData);
				resumeLibraryService.sendTestimonial(interviewPostData, res => {
					this.setState({ testimonialModalStatus: false })
					if (res.data.Success) {
						message.success("发送感谢信成功", 4);
					} else {
						message.error("发送感谢信失败 " + res.data.Errors[0], 4);
					}
				}, err => message.error("发送感谢信失败", 4))
			}
		})

	}




	disabledDate = (startValue) => {
		const endValue = new Date();
		if (!startValue || !endValue) {
			return false;
		}
		return startValue.valueOf() > endValue.valueOf();
	}

	render() {
		// const arrange_inte_time = this.state.arrange_inte_time
		// console.log(this.props.access.resumeLibrary)
		console.log(this.state.offers_resume_type)

		return (
			<div className="app-module-item">
				{this.state.offerModalStatus &&
					<Modal width="1000px"
						visible={this.state.offerModalStatus}
						title="发送Offer"
						destroyOnClose={true}
						onCancel={this.closeOfferModal}
						onOk={this.submitOffer} >
						<div className="app-modal-item">
							{(() => {
								switch (this.state.interviewDataStatus) {
									case "reload":
									case "loaded":
										return (
											<Form layout="inline">
												<Row>
													<Col span={24}>
														<div style={{ marginBottom: "15px", textAlign: "left", marginLeft: "58px" }}>
															{/*<Form.Item label="时间">
											<DatePicker value={this.state.offer_time ? 
												moment(this.state.offer_time) : null}
												style={{width:"240px"}}
												onChange={this.setOfferTime} />
										</Form.Item>*/}
															<Form.Item label="录用时间">
																{this.props.form.getFieldDecorator('offer_time', {
																	rules: [{ required: true, message: '请输入录用时间' }],
																	initialValue: null
																})(<DatePicker style={{ width: "120px" }} />)}
															</Form.Item>
														</div>
													</Col>
													<Col span={12}>
														<div style={{ marginBottom: "15px" }}>
															<Form.Item label="发送Offer方式">
																{this.props.form.getFieldDecorator('interviewee_remind_type', {
																	rules: [{ required: true, message: '请选择发送Offer方式' }],
																	initialValue: ""
																})(
																	<Select style={{ width: "240px" }}
																		onSelect={this.setIntervieweeRemindType}>
																		<Select.Option value="sms_template">短信</Select.Option>
																		<Select.Option value="email_template">邮件</Select.Option>
																	</Select>
																)}
															</Form.Item>
														</div>
													</Col>
													<Col span={12}>
														<div style={{ marginBottom: "15px" }}>
															<Form.Item label="发送Offer模版">
																{this.props.form.getFieldDecorator('interviewee_remind_temp_id', {
																	rules: [{ required: true, message: '请选择发送Offer模版' }],
																	initialValue: ""
																})(
																	<Select style={{ width: "240px" }}
																		onSelect={this.setIntervieweeRemindTemp}>
																		{this.state.intervieweeTemplates.map((template, index) => (
																			<Select.Option key={index} value={template.id}>
																				{template.name}
																			</Select.Option>
																		))}
																	</Select>
																)}
															</Form.Item>
														</div>
													</Col>
													<Col span={24}>
														<div style={{ marginBottom: "15px" }}>
															<Form.Item label="模版内容">
																{this.props.form.getFieldDecorator('intervieweeCurrentTemplateContent', {
																	rules: [],
																	initialValue: this.state.intervieweeCurrentTemplate.content
																})(<Input.TextArea disabled rows={5} style={{ width: "716px" }}>
																</Input.TextArea>)}
															</Form.Item>
														</div>
													</Col>
												</Row>
											</Form>
										)
									case "error":
										return (
											<div style={{ textAlign: 'center', margin: '100px 0px' }}>
												{webConfig.httpFetchErrorInformation}
											</div>);
									case "loading":
									case "unload":
										return (
											<div style={{ textAlign: 'center', margin: '100px 0px' }}>
												<Spin size="large" />
											</div>);
									default:
										return null;
								}
							})()}
						</div>
					</Modal>
				}

				{this.state.testimonialModalStatus &&
					<Modal width="1000px"
						visible={this.state.testimonialModalStatus}
						title="发送感谢信"
						destroyOnClose={true}
						onCancel={this.closeTestimonialModal}
						onOk={this.submitTestimonial} >
						<div className="app-modal-item">
							{(() => {
								switch (this.state.interviewDataStatus) {
									case "reload":
									case "loaded":
										return (
											<Form layout="inline">
												<Row>

													<Col span={12}>
														<div style={{ marginBottom: "15px" }}>
															<Form.Item label="发送方式">
																{this.props.form.getFieldDecorator('interviewee_remind_type', {
																	rules: [{ required: true, message: '请选择发送方式' }],
																	initialValue: ""
																})(
																	<Select style={{ width: "240px" }}
																		onSelect={this.setIntervieweeRemindType}>
																		<Select.Option value="sms_template">短信</Select.Option>
																		<Select.Option value="email_template">邮件</Select.Option>
																	</Select>
																)}
															</Form.Item>
														</div>
													</Col>
													<Col span={12}>
														<div style={{ marginBottom: "15px" }}>
															<Form.Item label="发送模版">
																{this.props.form.getFieldDecorator('interviewee_remind_temp_id', {
																	rules: [{ required: true, message: '请选择发送模版' }],
																	initialValue: ""
																})(
																	<Select style={{ width: "240px" }}
																		onSelect={this.setIntervieweeRemindTemp}>
																		{this.state.intervieweeTemplates.map((template, index) => (
																			<Select.Option key={index} value={template.id}>
																				{template.name}
																			</Select.Option>
																		))}
																	</Select>
																)}
															</Form.Item>
														</div>
													</Col>
													<Col span={24}>
														<div style={{ marginBottom: "15px" }}>
															<Form.Item label="模版内容">
																{this.props.form.getFieldDecorator('intervieweeCurrentTemplateContent', {
																	rules: [],
																	initialValue: this.state.intervieweeCurrentTemplate.content
																})(<Input.TextArea disabled rows={5} style={{ width: "716px" }}>
																</Input.TextArea>)}
															</Form.Item>
														</div>
													</Col>
												</Row>
											</Form>
										)
									case "error":
										return (
											<div style={{ textAlign: 'center', margin: '100px 0px' }}>
												{webConfig.httpFetchErrorInformation}
											</div>);
									case "loading":
									case "unload":
										return (
											<div style={{ textAlign: 'center', margin: '100px 0px' }}>
												<Spin size="large" />
											</div>);
									default:
										return null;
								}
							})()}
						</div>
					</Modal>
				}

				{this.state.interviewModalStatus &&
					<Modal width="1000px"
						visible={this.state.interviewModalStatus}
						title="安排面试"
						destroyOnClose={true}
						onCancel={this.closeInterviewModal}
						onOk={this.submitInterview} >
						<div className="app-modal-item">
							{(() => {
								switch (this.state.interviewDataStatus) {
									case "reload":
									case "loaded":
										return (
											<div>
												<Row>
													<Col span={12} style={{ marginBottom: "15px" }}>
														<span style={{ width: "120px", display: "inline-block", textAlign: "right" }}>
															姓名:
												</span>
														<span style={{ width: "240px", display: "inline-block", textAlign: "left", paddingLeft: "10px" }}>
															{this.state.interviewData.username}
														</span>
													</Col>
													<Col span={12} style={{ marginBottom: "15px" }}>
														<span style={{ width: "120px", display: "inline-block", textAlign: "right" }}>
															年龄:
												</span>
														<span style={{ width: "240px", display: "inline-block", textAlign: "left", paddingLeft: "10px" }}>
															{this.state.interviewData.age}
														</span>
													</Col>
													<Col span={12} style={{ marginBottom: "15px" }}>
														<span style={{ width: "120px", display: "inline-block", textAlign: "right" }}>
															联系电话:
												</span>
														<span style={{ width: "240px", display: "inline-block", textAlign: "left", paddingLeft: "10px" }}>
															{this.state.interviewData.mobile}
														</span>
													</Col>
													<Col span={12} style={{ marginBottom: "15px" }}>
														<span style={{ width: "120px", display: "inline-block", textAlign: "right" }}>
															邮箱:
												</span>
														<span style={{ width: "240px", display: "inline-block", textAlign: "left", paddingLeft: "10px" }}>
															{this.state.interviewData.email}
														</span>
													</Col>
												</Row>
												<Form onSubmit={this.submitInterview} className="login-form" layout="inline">
													<Row>
														<Col span={12}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="面试轮次">
																	{this.props.form.getFieldDecorator('interview_times', {
																		rules: [{ required: true, message: '请输入面试轮次' }],
																		initialValue: this.state.interviewData.interview_times
																	})(<InputNumber style={{ width: "240px" }} />)}
																</Form.Item>
															</div>
														</Col>
														<Col span={12}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="面试时间">
																	{this.props.form.getFieldDecorator('interview_date', {
																		rules: [{ required: true, message: '请输入面试时间' }],
																		initialValue: null
																	})(<DatePicker style={{ width: "120px" }} />)}
																</Form.Item>
																<Form.Item>
																	{this.props.form.getFieldDecorator('interview_time', {
																		rules: [{ required: true, message: '请输入面试时间' }],
																		initialValue: null
																	})(<TimePicker minuteStep={30} style={{ width: "120px", height: "39px", lineHeight: "39px" }} format={"HH:mm"} />)}
																</Form.Item>
															</div>
														</Col>
														<Col span={12}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="面试职位">
																	{this.props.form.getFieldDecorator('interview_jobs', {
																		rules: [{ required: true, message: '请输入面试职位' }],
																		initialValue: this.state.interviewSubmitData.interview_jobs
																	})(<Input style={{ width: "240px" }} />)}
																</Form.Item>
															</div>
														</Col>
														<Col span={12}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="面试官">
																	{this.props.form.getFieldDecorator('interviewer_name', {
																		rules: [{ required: true, message: '请输入面试官' }],
																		initialValue: ""
																	})(
																		<Select mode="combobox"
																			style={{ width: "240px" }}
																			onSearch={this.selectEmployee}
																			filterOption={false}
																			placeholder="请输入员工姓名"
																			onSelect={this.setInterviewer} >
																			{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
																				this.props.employeeManagement.employeeList.Data.map(employee => {
																					return (
																						<Select.Option key={employee.id}
																							value={employee.real_name}
																							employee_id={employee.id}
																							style={{ width: "220px" }}>
																							{employee.real_name}
																						</Select.Option>
																					)
																				})}
																		</Select>
																	)}
																</Form.Item>
															</div>
														</Col>
														<Col span={12}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="面试者提醒方式">
																	{this.props.form.getFieldDecorator('interviewee_remind_type', {
																		rules: [{ required: true, message: '请选择面试者提醒方式' }],
																		initialValue: ""
																	})(
																		<Select style={{ width: "240px" }}
																			onSelect={this.setIntervieweeRemindType}>
																			<Select.Option value="sms_template">短信</Select.Option>
																			<Select.Option value="email_template">邮件</Select.Option>
																		</Select>
																	)}
																</Form.Item>
															</div>
														</Col>
														<Col span={12}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="面试者提醒模版">
																	{this.props.form.getFieldDecorator('interviewee_remind_temp_id', {
																		rules: [{ required: true, message: '请选择面试者提醒模版' }],
																		initialValue: ""
																	})(
																		<Select style={{ width: "240px" }}
																			onSelect={this.setIntervieweeRemindTemp}>
																			{this.state.intervieweeTemplates.map((template, index) => (
																				<Select.Option key={index} value={template.id}>
																					{template.name}
																				</Select.Option>
																			))}
																		</Select>
																	)}
																</Form.Item>
															</div>
														</Col>
														<Col span={24}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="提醒模版内容">
																	{this.props.form.getFieldDecorator('intervieweeCurrentTemplateContent', {
																		rules: [],
																		initialValue: this.state.intervieweeCurrentTemplate.content
																	})(<Input.TextArea disabled rows={5} style={{ width: "716px" }}>
																	</Input.TextArea>)}
																</Form.Item>
															</div>
														</Col>
														<Col span={12}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="面试官提醒方式">
																	{this.props.form.getFieldDecorator('interviewer_remind_type', {
																		rules: [{ required: true, message: '请选择面试官提醒方式' }],
																		initialValue: ""
																	})(
																		<Select style={{ width: "240px" }}
																			onSelect={this.setInterviewerRemindType}>
																			<Select.Option value="corporatewechat_template">企业微信</Select.Option>
																			<Select.Option value="email_template">邮件</Select.Option>
																		</Select>
																	)}
																</Form.Item>
															</div>
														</Col>
														<Col span={12}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="面试官提醒模版">
																	{this.props.form.getFieldDecorator('interviewer_remind_temp_id', {
																		rules: [{ required: true, message: '请选择面试官提醒模版' }],
																		initialValue: ""
																	})(
																		<Select style={{ width: "240px" }}
																			onSelect={this.setInterviewerRemindTemp}>
																			{this.state.interviewerTemplates.map((template, index) => (
																				<Select.Option key={index} value={template.id}>
																					{template.name}
																				</Select.Option>
																			))}
																		</Select>
																	)}
																</Form.Item>
															</div>
														</Col>
														<Col span={24}>
															<div style={{ marginBottom: "15px" }}>
																<Form.Item label="提醒模版内容">
																	{this.props.form.getFieldDecorator('interviewerCurrentTemplateContent', {
																		rules: [],
																		initialValue: this.state.interviewerCurrentTemplate.content
																	})(<Input.TextArea disabled rows={5} style={{ width: "716px" }}>
																	</Input.TextArea>)}
																</Form.Item>
															</div>
														</Col>
													</Row>
													<Divider type="horizontal">其他反馈信息</Divider>
													<div>
														<span style={{ width: "120px", display: "inline-block", textAlign: "right" }}>简历分析建议:</span>
														<span style={{ width: "716px", display: "inline-block", textAlign: "left", paddingLeft: "10px" }}>
															{this.state.interviewData.suggestion}
														</span>
													</div>
													{this.state.interviewData.suggestions.map((suggestion, index) => (
														<div key={index}>
															<span style={{ width: "120px", display: "inline-block", textAlign: "right" }}>{suggestion.id}: </span>
															<span style={{ width: "716px", display: "inline-block", textAlign: "left", paddingLeft: "10px" }}>
																{suggestion.suggestion}
															</span>
														</div>
													))}
												</Form>
											</div>)
									case "error":
										return (
											<div style={{ textAlign: 'center', margin: '100px 0px' }}>
												{webConfig.httpFetchErrorInformation}
											</div>);
									case "loading":
									case "unload":
										return (
											<div style={{ textAlign: 'center', margin: '100px 0px' }}>
												<Spin size="large" />
											</div>);
									default:
										return null;
								}
							})()}
						</div>
					</Modal>
				}
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="简历库"
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					onOk={this.publicSubmit} >
					<div className="app-modal-item">
						{(() => {
							switch (this.state.currentDataStatus) {
								case "reload":
								case "loaded":
									return (
										<Form onSubmit={this.publicSubmit} className="login-form" layout="inline">
											<div style={{ textAlign: "left" }}>基本信息</div>
											<hr />
											<Row style={{ marginBottom: "10px" }}>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="姓名">
															{this.props.form.getFieldDecorator('username', {
																rules: [{ required: true, message: '请输入姓名' }],
																initialValue: this.state.currentData.username
															})(<Input style={{ width: "240px" }} />)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="性别">
															{this.props.form.getFieldDecorator('gender', {
																rules: [{ required: true, message: '请选择性别' }],
																initialValue: this.state.currentData.gender
															})(
																<Radio.Group style={{ width: "240px", textAlign: "left" }}>
																	<Radio.Button value={0}>男</Radio.Button>
																	<Radio.Button value={1}>女</Radio.Button>
																</Radio.Group>
															)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="出生日期">
															{this.props.form.getFieldDecorator('birthday', {
																rules: [{ required: true, message: '请输入出生日期' }],
																initialValue: this.state.currentData.birthday ?
																	moment(this.state.currentData.birthday) : null
															})(<DatePicker style={{ width: "240px" }}
																disabledDate={this.disabledDate} />)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="开始工作日期">
															{this.props.form.getFieldDecorator('start_working_time', {
																rules: [{ required: true, message: '请输入开始工作日期' }],
																initialValue: this.state.currentData.start_working_time ?
																	moment(this.state.currentData.start_working_time) : null
															})(<DatePicker style={{ width: "240px" }} disabledDate={this.disabledDate} />)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="手机号">
															{this.props.form.getFieldDecorator('mobile', {
																rules: [{ required: true, message: '请输入手机号' }],
																initialValue: this.state.currentData.mobile
															})(<Input style={{ width: "240px" }} />)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="邮箱">
															{this.props.form.getFieldDecorator('email', {
																rules: [{ required: true, message: '请输入邮箱' }],
																initialValue: this.state.currentData.email
															})(<Input style={{ width: "240px" }} />)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="居住地">
															{this.props.form.getFieldDecorator('place_of_residence', {
																rules: [{ required: true, message: '请输入居住地' }],
																initialValue: this.state.currentData.place_of_residence
															})(<Input style={{ width: "240px" }} />)}
														</Form.Item>
													</div>
												</Col>
											</Row>
											<div style={{ textAlign: "left" }}>目前年收入</div>
											<hr />
											<Row style={{ marginBottom: "10px" }}>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="目前年收入(万)">
															{this.props.form.getFieldDecorator('current_salary', {
																rules: [{ required: true, message: '请输入目前年收入' }],
																initialValue: this.state.currentData.current_salary
															})(<InputNumber style={{ width: "240px" }} />)}
														</Form.Item>
													</div>
												</Col>
											</Row>
											<div style={{ textAlign: "left" }}>求职意向</div>
											<hr />
											<Row style={{ marginBottom: "10px" }}>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="期望年薪(万)">
															{this.props.form.getFieldDecorator('expected_salary', {
																rules: [{ required: true, message: '请输入期望年薪' }],
																initialValue: this.state.currentData.expected_salary
															})(<InputNumber style={{ width: "240px" }} />)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="部门">
															{this.props.form.getFieldDecorator('department_id', {
																rules: [{ required: true, message: '请选择部门' }],
																initialValue: this.state.currentData.department_id + ""
															})(<TreeSelect style={{ width: "240px" }}
																placeholder="请选择部门"
																showSearch={false}
																autoExpandParent={true}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeDefaultExpandAll
																onSelect={this.setDepartment}>
																{this.renderTreeNodes(this.state.departments)}
															</TreeSelect>
															)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="职位">
															{this.props.form.getFieldDecorator('position_id', {
																rules: [{ required: true, message: '请选择职位' }],
																initialValue: this.state.currentData.position_id
															})(
																<Select style={{ width: "240px" }} >
																	{this.state.positions && this.state.positions.map(position => (
																		<Select.Option key={position.id}
																			position_id={position.id}
																			value={position.id}>
																			{position.name}
																		</Select.Option>
																	))}
																</Select>
															)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="到岗时间">
															{this.props.form.getFieldDecorator('to_post_time', {
																rules: [{ required: true, message: '请输入到岗时间' }],
																initialValue: this.state.currentData.to_post_time ?
																	moment(this.state.currentData.to_post_time) : null
															})(<DatePicker style={{ width: "240px" }} />)}
														</Form.Item>
													</div>
												</Col>
												<Col span={12}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="工作类型">
															{this.props.form.getFieldDecorator('work_type', {
																rules: [{ required: true, message: '请选择工作类型' }],
																initialValue: this.state.currentData.work_type.toString()
															})(
																<Select style={{ width: "240px" }}>
																	{this.state.work_types.map(type => (
																		<Select.Option key={type.value}
																			work_type_id={type.value}
																			value={type.value}>
																			{type.text}
																		</Select.Option>
																	))}
																</Select>
															)}
														</Form.Item>
													</div>
												</Col>
											</Row>
											<div style={{ textAlign: "left" }}>
												<span>工作经验</span>
												<Button type="primary"
													style={{ float: "right", marginRight: "15px" }}
													onClick={this.addWorkExperience}>添加工作经验</Button>
												<div style={{ clear: "both" }}></div>
											</div>
											<hr />
											{this.state.currentData.work_experiences.map((experience, index) => {
												if (!experience.deleted) {
													return (
														<Row key={index} style={{ marginBottom: "10px" }}>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="开始时间">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].start_time', {
																			rules: [{ required: true, message: '请输入开始时间' }],
																			initialValue: experience.start_time ?
																				moment(experience.start_time) : null
																		})(<DatePicker style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="结束时间">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].end_time', {
																			rules: [{ required: true, message: '请输入结束时间' }],
																			initialValue: experience.end_time ?
																				moment(experience.end_time) : null
																		})(<DatePicker style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="公司">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].company_name', {
																			rules: [{ required: true, message: '请输入公司' }],
																			initialValue: experience.company_name
																		})(<Input style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="行业">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].industry', {
																			rules: [{ required: true, message: '请输入行业' }],
																			initialValue: experience.industry
																		})(<Input style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="部门">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].department_name', {
																			rules: [{ required: true, message: '请输入部门' }],
																			initialValue: experience.department_name
																		})(<Input style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="职能">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].responsibility', {
																			rules: [{ required: true, message: '请输入职能' }],
																			initialValue: experience.responsibility
																		})(<Input style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="职位">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].position_name', {
																			rules: [{ required: true, message: '请输入职位' }],
																			initialValue: experience.position_name
																		})(<Input style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="公司性质">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].company_kind', {
																			rules: [{ required: true, message: '请选择公司性质' }],
																			initialValue: experience.company_kind
																		})(
																			<Select style={{ width: "240px" }}>
																				{this.state.company_kinds.map(kind => (
																					<Select.Option key={kind.value}
																						kind_id={kind.value}
																						value={kind.value}>
																						{kind.text}
																					</Select.Option>
																				))}
																			</Select>
																		)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="公司规模">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].company_size', {
																			rules: [{ required: true, message: '请选择公司规模' }],
																			initialValue: experience.company_size
																		})(
																			<Select style={{ width: "240px" }}>
																				{this.state.company_size.map(size => (
																					<Select.Option key={size.value}
																						size_id={size.value}
																						value={size.value}>
																						{size.text}
																					</Select.Option>
																				))}
																			</Select>
																		)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={24}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="工作描述">
																		{this.props.form.getFieldDecorator('work_experiences[' + index + '].work_description', {
																			rules: [{ required: true, message: '请输入工作描述' }],
																			initialValue: experience.work_description
																		})(<Input.TextArea rows={5} style={{ width: "710px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={24}>
																<span style={{ textAlign: "center", textDecoration: "underline", color: "blue", cursor: "pointer" }}
																	onClick={this.deleteWorkExperience.bind(this, index)}>删除工作经验</span>
															</Col>
														</Row>
													)
												}
												return null;
											})}
											<div style={{ textAlign: "left" }}>
												<span>教育经历</span>
												<Button type="primary"
													style={{ float: "right", marginRight: "15px" }}
													onClick={this.addEducationExperience}>添加教育经历</Button>
												<div style={{ clear: "both" }}></div>
											</div>
											<hr />
											{this.state.currentData.education_experiences.map((experience, index) => {
												if (!experience.deleted) {
													return (
														<Row key={index} style={{ marginBottom: "10px" }}>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="开始时间">
																		{this.props.form.getFieldDecorator('education_experiences[' + index + '].start_time', {
																			rules: [{ required: true, message: '请输入开始时间' }],
																			initialValue: experience.start_time ?
																				moment(experience.start_time) : null
																		})(<DatePicker style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="结束时间">
																		{this.props.form.getFieldDecorator('education_experiences[' + index + '].end_time', {
																			rules: [{ required: true, message: '请输入结束时间' }],
																			initialValue: experience.end_time ?
																				moment(experience.end_time) : null
																		})(<DatePicker style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="学校">
																		{this.props.form.getFieldDecorator('education_experiences[' + index + '].school_name', {
																			rules: [{ required: true, message: '请输入学校' }],
																			initialValue: experience.school_name
																		})(<Input style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="专业">
																		{this.props.form.getFieldDecorator('education_experiences[' + index + '].profession', {
																			rules: [{ required: true, message: '请输入专业' }],
																			initialValue: experience.profession
																		})(<Input style={{ width: "240px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="学历/学位">
																		{this.props.form.getFieldDecorator('education_experiences[' + index + '].educational_level', {
																			rules: [{ required: true, message: '请选择学历/学位' }],
																			initialValue: experience.educational_level
																		})(
																			<Select style={{ width: "240px" }}>
																				{this.state.education_levels.map(level => (
																					<Select.Option key={level.value}
																						level_id={level.value}
																						value={level.value}>
																						{level.text}
																					</Select.Option>
																				))}
																			</Select>
																		)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={12}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="是否全日制">
																		{this.props.form.getFieldDecorator('education_experiences[' + index + '].is_all_day', {
																			rules: [{ required: true, message: '请选择是否全日制' }],
																			initialValue: experience.is_all_day
																		})(
																			<Radio.Group style={{ width: "240px", textAlign: "left" }}>
																				<Radio.Button value={true}>是</Radio.Button>
																				<Radio.Button value={false}>否</Radio.Button>
																			</Radio.Group>
																		)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={24}>
																<div style={{ marginBottom: "15px" }}>
																	<Form.Item label="专业描述">
																		{this.props.form.getFieldDecorator('education_experiences[' + index + '].profession_description', {
																			rules: [{ required: true, message: '请输入专业描述' }],
																			initialValue: experience.profession_description
																		})(<Input.TextArea rows={5} style={{ width: "710px" }} />)}
																	</Form.Item>
																</div>
															</Col>
															<Col span={24}>
																<span style={{ textAlign: "center", textDecoration: "underline", color: "blue", cursor: "pointer" }}
																	onClick={this.deleteEducationExperience.bind(this, index)}>删除教育经历</span>
															</Col>
														</Row>
													)
												}
												return null;
											})}
											<div style={{ textAlign: "left" }}>其他</div>
											<hr />
											<Row style={{ marginBottom: "10px" }}>
												<Col span={24}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="渠道">
															{this.props.form.getFieldDecorator('channel', {
																rules: [],
																initialValue: this.state.currentData.channel
															})(<Input style={{ width: "710px" }} />)}
														</Form.Item>
													</div>
												</Col>
												<Col span={24}>
													<div style={{ marginBottom: "15px" }}>
														<Form.Item label="简历分析建议">
															{this.props.form.getFieldDecorator('suggestion', {
																rules: [],
																initialValue: this.state.currentData.suggestion
															})(<Input.TextArea rows={5} style={{ width: "710px" }} />)}
														</Form.Item>
													</div>
												</Col>
											</Row>
										</Form>)
								case "error":
									return (
										<div style={{ textAlign: 'center', margin: '100px 0px' }}>
											{webConfig.httpFetchErrorInformation}
										</div>);
								case "loading":
								case "unload":
									return (
										<div style={{ textAlign: 'center', margin: '100px 0px' }}>
											<Spin size="large" />
										</div>);
								default:
									return null;
							}
						})()}
					</div>
				</Modal>
				<div style={{ marginBottom: "20px" }}>
					{this.props.access.resumeLibrary.c_value && <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.createResume}>
							<Icon type="plus-circle-o" />
							<span>新增</span>
						</Button>
					</div>}
					{this.props.access.resumeLibrary.d_value && <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}
					{this.props.access.resumeLibrary.import_value && <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={() => this.setState({ importModalStatus: true })}>
							<Icon type="cloud-upload-o" />
							<span>导入</span>
						</Button>
					</div>}
					{this.props.access.resumeLibrary.export_value && <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.publicExport}>
							<Icon type="cloud-download-o" />
							<span>导出</span>
						</Button>
					</div>}

					{this.props.access.resumeLibrary.send_offer_value && <div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>

						{this.state.offers_resume_type == 1 &&
							<div>
								<Button type="primary"  onClick={this.transResumeType.bind(this,2)} style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span>移到人才库</span>
									<Icon type="right" />
								</Button>
								<Button type="primary" onClick={this.transResumeType.bind(this,3)}>
									<span>移到黑名单</span>
									<Icon type="right" />
								</Button>
							</div>
						}{this.state.offers_resume_type == 2 &&
							<div>
								<Button type="primary" onClick={this.transResumeType.bind(this,1)} style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span>移到简历库</span>
									<Icon type="right" />
								</Button>
								<Button type="primary" onClick={this.transResumeType.bind(this,3)}>
									<span>移到黑名单</span>
									<Icon type="right" />
								</Button>
							</div>
						}{this.state.offers_resume_type == 3 &&
							<div>
								<Button type="primary" onClick={this.transResumeType.bind(this,1)} style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<span>移到简历库</span>
									<Icon type="right" />
								</Button>
								<Button type="primary" onClick={this.transResumeType.bind(this,2)} >
									<span>移到人才库</span>
									<Icon type="right" />
								</Button>
							</div>}




					</div>}

					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<Input.Search
							placeholder="姓名"
							onSearch={this.setNameFilter}
							onChange={this.changeNameFilter}
							style={{ width: 200 }}
							defaultValue={this.props[this.moduleName][this.childModuleName].filters.name}
							enterButton />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "10px" }}>选择职位: </span>
						<Select placeholder="选择职位" style={{ width: "200px" }}
							value={this.props[this.moduleName][this.childModuleName].filters.position_id}
							onSelect={this.setPositionFilter}>
							<Select.Option value="">全部</Select.Option>
							{this.props[this.moduleName][this.childModuleName].positions.map(position =>
								<Select.Option key={position.Value} value={position.Value}>
									{position.Text}
								</Select.Option>)}
						</Select>
					</div>
					<div style={{ clear: "both" }}></div>
				</div>
				<div>{this.publicImportView()}</div>
				<div>
					<Tabs defaultActiveKey="1" onChange={this.changeOffersResumeType}>
						<Tabs.TabPane tab="简历库" key="1">
							{this.publicTableView()}
						</Tabs.TabPane>
						<Tabs.TabPane tab="人才库" key="2">
							{this.publicTableView()}
						</Tabs.TabPane>
						<Tabs.TabPane tab="黑名单" key="3">
							{this.publicTableView()}
						</Tabs.TabPane>
					</Tabs></div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		recruitment: state.recruitment,
		employeeManagement: state.employeeManagement
	}
}

const mapDispatchToProps = {
	changeResumeLibrary,
	selectResumeLibrary,
	updateResumeLibrary,
	fetchEmployeesList
}

ResumeLibrary = Form.create()(ResumeLibrary);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ResumeLibrary));





// WEBPACK FOOTER //
// ./src/routes/Recruitment/ResumeLibrary.js